//Lib 
import { mapState } from "vuex";

// Api
import api from '@/api/baseApi';

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import {
    API_CALL_STATUS,
    POPUP_ID,
} from "@/constant/baseConstant";
import { EXTRA_SERVICE_TYPE } from "@/constant/extraService";
import { SERVICE_TYPE } from "@/constant/rental";

// Function 
const queryString = require('query-string');

export default {

    extends: baseExtraService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    data() {

        return {
            licenseType: 2,
            note: null,
            packageList: []
        };
    },

    mounted() {

    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.EXTRA_SERVICE_LICENSE);
        },
        //#endregion 

        //#region Expand image threshold send request
        send() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: EXTRA_SERVICE_TYPE.LICENSE,
                    licenseType: this.licenseType,
                    note: this.note,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.createRequest(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion 
    },
}